const STATUS_STYLES = {
  new: 'bg-blue-100 text-blue-700',
  saved: 'bg-green-100 text-green-700',
  dismissed: 'bg-gray-100 text-gray-500',
  acted_on: 'bg-vault-gold/20 text-vault-gold-dark',
};

export default function TrendMatchCard({ match, onUpdateStatus, onApplyToPitch }) {
  const trend = match.trend_alerts;
  const idea = match.ideas;

  return (
    <div className={`bg-white rounded-xl border p-5 transition-all ${
      match.status === 'dismissed' ? 'border-gray-200 opacity-60' : 'border-vault-border'
    }`}>
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${STATUS_STYLES[match.status]}`}>
              {match.status === 'acted_on' ? 'Applied' : match.status.charAt(0).toUpperCase() + match.status.slice(1)}
            </span>
            {match.match_score && (
              <span className="text-xs text-gray-400">{Math.round(match.match_score * 100)}% match</span>
            )}
          </div>
          <h3 className="font-semibold text-vault-navy text-sm">
            {trend?.trend_topic}
          </h3>
          <p className="text-xs text-gray-400 mt-0.5">
            matched with <span className="font-medium text-vault-navy">{idea?.title}</span>
          </p>
        </div>
      </div>

      {/* Explanation */}
      <p className="text-sm text-gray-600 mb-3">{match.match_explanation}</p>

      {/* Pitch angle suggestion */}
      {match.suggested_pitch_angle && (
        <div className="p-3 bg-yellow-50 border border-yellow-100 rounded-lg mb-3">
          <div className="text-xs font-medium text-yellow-700 mb-1">Suggested Pitch Angle</div>
          <p className="text-sm text-yellow-800">{match.suggested_pitch_angle}</p>
        </div>
      )}

      {/* Actions */}
      <div className="flex gap-2">
        {match.status !== 'acted_on' && (
          <button
            onClick={() => onApplyToPitch?.(match)}
            className="flex-1 py-1.5 bg-vault-gold hover:bg-vault-gold-dark text-white text-sm font-medium rounded-lg transition-colors"
          >
            Apply to Pitch Builder
          </button>
        )}

        {match.status === 'new' && (
          <>
            <button
              onClick={() => onUpdateStatus(match.id, 'saved')}
              className="px-3 py-1.5 border border-green-200 text-green-600 text-sm font-medium rounded-lg hover:bg-green-50 transition-colors"
            >
              Save
            </button>
            <button
              onClick={() => onUpdateStatus(match.id, 'dismissed')}
              className="px-3 py-1.5 border border-vault-border text-gray-400 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors"
            >
              Dismiss
            </button>
          </>
        )}

        {match.status === 'saved' && (
          <button
            onClick={() => onUpdateStatus(match.id, 'dismissed')}
            className="px-3 py-1.5 border border-vault-border text-gray-400 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors"
          >
            Dismiss
          </button>
        )}

        {match.status === 'dismissed' && (
          <button
            onClick={() => onUpdateStatus(match.id, 'new')}
            className="px-3 py-1.5 border border-vault-border text-gray-500 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors"
          >
            Restore
          </button>
        )}
      </div>
    </div>
  );
}
